import service from "@/utils/request";
export interface rollCallListData {
  page: number;
  page_size: number;
  roll_call_id?: number;
  class_id?: number;
  teacher_id?: number;
  course_id?: number;
  staff_id?: number;
  roll_call_start_date?: string;
  roll_call_end_date?: string;
  lesson_start_date?: string;
  lesson_end_date?: string;
  consume_number_start?: string;
  consume_number_end?: string;
  real_consume_number_start?: string;
  real_consume_number_end?: string;
  sort_field?: string;
  sort_type?: string;
  course_type?: number;
  subject_ids?: number[];
  status?: number;
  classroom_id?: number;
}
//点名记录列表
export const rollCallList = (data: rollCallListData) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/list",
    method: "post",
    data,
  });
};
// 导出
export interface exportData {
  roll_call_id?: number;
  class_id?: number;
  teacher_id?: number;
  course_id?: number;
  staff_id?: number;
  roll_call_start_date?: string;
  roll_call_end_date?: string;
  lesson_start_date?: string;
  lesson_end_date?: string;
}
export const exportRollList = (params: exportData) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/student/export",
    method: "get",
    params,
  });
};
export const exportRollListClss = (params: exportData) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/export",
    method: "get",
    params,
  });
};
export interface leaveListData {
  page: number;
  page_size: number;
  key_word?: string;
  status?: number;
  intent_arr?: [];
}
//请假列表
export const leaveList = (data: leaveListData) => {
  return service({
    url: "/api/v1/student/leave/list",
    method: "post",
    data,
  });
};
//请假筛选
export const leaveStatus = () => {
  return service({
    url: "/api/v1/student/leave/status",
    method: "get",
  });
};
//请假详情
export const leavedetail = (params: { leave_id: number }) => {
  return service({
    url: "/api/v1/student/leave/detail",
    method: "get",
    params,
  });
};
//请假通过
export const leavePass = (data: { leave_id: number }) => {
  return service({
    url: "/api/v1/student/leave/pass",
    method: "post",
    data,
  });
};
//请假拒绝
export const leaveReject = (data: { leave_id: number; remark?: string }) => {
  return service({
    url: "/api/v1/student/leave/reject",
    method: "post",
    data,
  });
};
//请假取消
export const leaveCancel = (data: { leave_id: number }) => {
  return service({
    url: "/api/v1/student/leave/cancel",
    method: "post",
    data,
  });
};
//点名某个编辑
export interface studentEditData {
  roll_call_student_id: number;
  student_status: number;
  consume_number: string;
  remark?: string;
}
export const studentEdit = (data: studentEditData) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/student/edit",
    method: "post",
    data,
  });
};
//点名记录编辑
export interface rollCallEditData {
  roll_call_id: number;
  lesson_date: number;
  lesson_start_time: string;
  lesson_end_time?: string;
  consume_number: string;
  lesson_content: string;
}
export const rollCallEdit = (data: rollCallEditData) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/edit",
    method: "post",
    data,
  });
};
//点名超上
export const studentExceedHandle = (data: { roll_call_student_id: number }) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/student/exceed_handle",
    method: "post",
    data,
  });
};
//点名记录
export interface exceedHandleData {
  page: number;
  page_size: number;
  code: number | string;
  relation_id: number;
}
export const exceedHandle = (params: exceedHandleData) => {
  return service({
    url: "/api/v1/operation/log/list",
    method: "get",
    params,
  });
};
//操作类型
export const exceedcode = () => {
  return service({
    url: "/api/v1/operation/log/code",
    method: "get",
  });
};
//临时学员添加列表
export const studentList = (params: { lesson_id: number }) => {
  return service({
    url: "/api/v1/class/lesson/student/list",
    method: "get",
    params,
  });
};
//临时学员添加
export interface studentAddData {
  roll_call_id: number;
  student_list: [];
}
export const studentAdd = (data: studentAddData) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/student/add",
    method: "post",
    data,
  });
};
//学员请假类型
export const studentLeaveType = () => {
  return service({
    url: "/api/v1/student/leave/leave_type",
    method: "get",
  });
};
//学员请假涉及的班级课次列表
export const classLessonList = (params: {
  start_time: number;
  end_time: number;
  student_id: number;
}) => {
  return service({
    url: "/api/v1/student/leave/class_lesson_list",
    method: "get",
    params,
  });
};
//学员请假添加
export interface leaveAddData {
  student_id: number;
  leave_type: number;
  start_time?: number;
  end_time?: number;
  cause?: string;
  images?: [];
}
export const leaveAdd = (data: leaveAddData) => {
  return service({
    url: "/api/v1/student/leave/add",
    method: "post",
    data,
  });
};
//课次学员列表
export const lessonStudentList = (params: { lesson_id: number }) => {
  return service({
    url: "/api/v1/class/lesson/student/list",
    method: "get",
    params,
  });
};
//课次学员列表删除
export const lessonStudentDel = (data: {
  lesson_id: number;
  student_id: number;
}) => {
  return service({
    url: "/api/v1/class/lesson/student/del",
    method: "post",
    data,
  });
};
//判断课程是否超时
export const courseAccount = (params: {
  student_id: number;
  course_id: number;
}) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/student/course_account",
    method: "get",
    params,
  });
};
//判断课程是否超时
export const courseAccountLog = (params: { roll_call_student_id: number }) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/student/course_account_log",
    method: "get",
    params,
  });
};
// 撤销点名
export const lessonCancelRollCall = (data: { roll_call_id: number }) => {
  return service({
    url: "/api/v1/class/lesson/cancel_roll_call",
    method: "post",
    data,
  });
};
// 修改教务老师
export const editEduTeacherApi = (data: any) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/student/edit/edu_teacher",
    method: "post",
    data,
  });
};
